import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { Row } from '../../../atoms/row/Row';
import InfoPopup from '../../shared/infoPopup/InfoPopup';
import { Checkbox } from '../../../atoms/checkbox/Checkbox';
import { Radio } from '../../../atoms/radio/Radio';

export const ModalFilterItem = ({
  title,
  description,
  category,
  options,
  optionsName,
  optionsLocaleString,
  selection,
  selectedFilters,
  onFilterChange,
  sort,
  sortFunction,
  labelFunction,
  t,
}) => {
  const handleCheckboxChange = (option, type) => {
    onFilterChange(option, type);
  };

  return (
    <Stack className="gap-2 border-b pb-4 border-customGray-200">
      <Row className="items-center gap-2">
        <Typography fontVariant="h8" textAlign="left">
          {t(title)}
        </Typography>
        {description && (
          <InfoPopup description={t(description)} displayDirection="right" />
        )}
      </Row>
      <div className="flex flex-wrap gap-2">
        {options
          .map((option, i) =>
            labelFunction(
              option,
              optionsName?.[i],
              optionsLocaleString?.[i],
              category
            )
          )
          .sort((a, b) => (!sort ? 0 : sortFunction(a, b)))
          .map((item) => {
            const { option } = item;
            const { name } = item;

            return (
              <label
                key={option}
                htmlFor={`modal-${option}`}
                className="inline-flex items-center bg-primary-100 px-2 py-2 rounded-lg"
              >
                {selection === 'single' ? (
                  <Radio
                    value={option}
                    checked={selectedFilters === option}
                    onChange={() => handleCheckboxChange(option, 'radio')}
                    name={`${title}-radio-modal`}
                    id={`modal-${option}`}
                  />
                ) : (
                  <Checkbox
                    value={option}
                    checked={selectedFilters?.includes(option)}
                    onChange={() => handleCheckboxChange(option, 'checkbox')}
                    id={`modal-${option}`}
                  />
                )}
                <Typography
                  as="span"
                  textAlign="left"
                  fontVariant="sm"
                  className="ml-2"
                >
                  {name}
                </Typography>
              </label>
            );
          })}
      </div>
    </Stack>
  );
};
